/** 适配器
 * 控制
 */

/**
 * 返回防抖函数  一段时间内频繁触发，只执行最后一次调用
 * @param {*} fn
 * @param {*} delay 限制时间 毫秒
 * @param {*} scope
 */
export function debounce(fn, delay, scope) {
  let timer = null
  const count = 1 // 返回函数对debounce作用域形成闭包

  return function () {
    // setTimeout()中this在非严格模式会指向window(或全局)对象，严格模式下为undefined,故需要当前环境的副本；
    const context = scope || this
    const args = arguments // 如果事件被触发，清除timer并重新开始计时

    clearTimeout(timer)
    // console.log(Date.now(), ", 触发第", count++, "次事件！")
    timer = setTimeout(function () {
      fn.apply(context, args)
      // console.log(Date.now(), ", 只有当高频事件停止，最后一次事件触发的超时调用才能在delay时间后执行!")
    }, delay)
  }
}

/**
 * 返回节流函数 一定时间内只执行一次，多余的调用不执行
 * @param {*} fn
 * @param {*} threshold 限制时间 毫秒
 * @param {*} scope
 */
export function throttle(fn, threshold, scope) {
  let prev = Date.now()
  return function () {
    const context = scope || this
    const args = arguments
    const now = Date.now()

    if (now - prev > threshold) {
      prev = now
      fn.apply(context, args)
    }
  }
}

const runlist = {}
/**
 * 一段时间内只执行一次
 * @param {*} name
 * @param {*} fn
 * @param {*} threshold
 * @param {*} scope
 * @returns
 */
export function throttleRun(name, fn, threshold, scope) {
  const now = Date.now()
  if (runlist[name] && now - runlist[name].prev < threshold) {
    console.log('throttleRun:', name, threshold, '被阻止重复执行')
    return
  }
  console.log('throttleRun:', name)
  runlist[name] = {
    prev: now
  }
  const context = scope || this
  fn.apply(context)
}

/**
 * 节流，执行最后一次
 * @param {any} fn 执行的方法
 * @param {any} threshold 毫秒
 * @param {any} scope this
 * @returns async function
 */
export function throttleRunLast(fn, threshold, scope) {
  let id = null // 全局变量
  return async function (params) {
    if (id != null) {
      clearTimeout(id)
      console.log('throttleRunLast-clearTimeout', id)
    }
    await new Promise((resolve, reject) => {
      id = setTimeout(function () {
        try {
          console.log('throttleRunLast-run')
          fn(params)
        } catch (error) {
          reject(error)
        }
        id = null
        resolve()
      }, threshold)
    })
  }
}

const promiseList = {}

/**
 * 单例执行异步方法
 * @param {*} name
 * @param {*} promiseFunc
 * @returns
 */
export async function singleRunPromise(name, promiseFunc) {
  const promiseObj = promiseList[name]
  if (promiseObj != undefined && promiseObj.constructor.name === 'Promise') {
    return promiseObj
  } else {
    return (promiseList[name] = promiseFunc().then((result) => {
      delete promiseList[name]
      return result
    }))
  }
}

// 测试代码
// async function aaaa(params) {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve(123456)
//     }, 3000)
//   })
// }

// function bbbb(params) {
//   onlyRunPromise('aaaaa', aaaa).then((v) => {
//     console.log(v)
//   })
//   onlyRunPromise('aaaaa', aaaa).then((v) => {
//     console.log(v)
//   })
//   onlyRunPromise('aaaaa', aaaa).then((v) => {
//     console.log(v)
//   })
// }
